import dayjs from 'dayjs';

import { Event } from 'store/api/event';
import { isEventNotStarted } from 'components/event-dashboard/helpers';

const MAX_SUBTRACT_MONTHS = 1;

/**
 * Returns the initial date range based on the given event.
 * If the event has finished, it will return a date range of one month before the event end date to the event end date.
 * If the event has not finished, it will return a date range from one month before the current date to the current date.
 * If the event has not started yet, it will return the event start date as both ends (never a reversed range).
 * @param {Event} event - The event object.
 * @return {[Date, Date]} - The initial date range.
 */
export const getInitialDateRange = (event: Event): [Date, Date] => {
  const today = dayjs();
  const eventEnd = dayjs(event.endDate);
  const eventStart = dayjs(event.startDate);
  const isEventFinished = today.isAfter(eventEnd);

  if (isEventNotStarted(event.startDate, today)) {
    return [eventStart.toDate(), eventStart.toDate()];
  }

  if (isEventFinished) {
    const minStart = eventEnd.subtract(MAX_SUBTRACT_MONTHS, 'month');
    const startDate = eventStart.isBefore(minStart) ? minStart : eventStart;
    return [startDate.toDate(), eventEnd.toDate()];
  }

  const minStart = today.subtract(MAX_SUBTRACT_MONTHS, 'month');
  const startDate = eventStart.isBefore(minStart) ? minStart : eventStart;
  return [startDate.toDate(), today.toDate()];
};
